var apiBaseUrl = 'https://agchimpapi.azurewebsites.net';
var productData = "";
var product_id = 0;
var metafields_product;
var customer_id = 0;
var customerData = '';
var wholesaleDiscount = 10;
var customShopifyData = "";
var taxExemptCode='';
$(document).ready(function () {
  console.log('loaded');

})
  localStorage.setItem('apiBaseUrl',apiBaseUrl);
  if (ShopifyAnalytics.meta.page.customerId !== undefined) {
    customer_id = ShopifyAnalytics.meta.page.customerId;
  }
  if(ShopifyAnalytics.meta.page.resourceId !== undefined){
  product_id = ShopifyAnalytics.meta.page.resourceId;
  }
  console.log(product_id);
  console.log(customer_id)
  var settings = {
  "url": "https://actokenproxy.azurewebsites.net/api/GetJWT?environment=production",
  "method": "GET",
  "timeout": 0,
  "type":"jsonp"
};

$.ajax(settings).done(function (response) {
    console.log(response);
   localStorage.setItem("agchimpToken", response.userJwtToken);
    localStorage.setItem("agchimp_shop_id", Shopify.shop.split(".")[0]);
      var verifyType = "";

    
      if(product_id>0){
        loadProductInfo();
      }
  
      if(customer_id>0){
        console.log(customer_id)
      var customer_object = [
      {
        name: "shopify_shop_id",
        value: localStorage["agchimp_shop_id"],
      },
      {
        name: "customer_id",
        value: ShopifyAnalytics.meta.page.customerId,
      },
      ];
        console.log(customer_object);
      exec("shopify_frontend_json_customer_object_s", customer_object,buildCustomer);
      }
}).fail(function(data){
   console.log(data.responseText);
   


})



function buildCustomer(data){
 customerData=data;
  console.log(customerData);
 
if(customerData.hasOwnProperty('company_name')){
  $('#chShowProfile-Block').prepend(`
    <div class="chContent-Body-Page-General-Title">
    <div class="chCBPROT-Heading">Company Information</div>
    <div class="chCBPROT-Action"></div>
    </div>
    
    <div class="chContent-Body-Page-General chContent-Body-Page-Profile">
    <div class="chContent-Body-Page-Content-Wrapper">
    <input type="hidden" id="chFormState" value="visible">
    <div id="chPersonalInfoSummary" class="chContent-Body-Page-Profile-Summary" style="display:none">
    <div class="chContent-BPPS-Info"><div class="chContent-BPPS-Info-Item chContent-BPPS-Info-Item-Bold"></div>
    <div class="chContent-BPPS-Info-Item">user14@agchimp.com</div>
    <div class="chContent-BPPS-Info-Item">
    <span id="chContent-acceptsMarketing-true" style="display:none">I accept</span><span id="chContent-acceptsMarketing-false" style="display:none">I don't accept</span>marketing from AgChimp LLC.</div>
    </div>
    <div class="chContent-BPPS-Edit">
    <button class="chButton chButton-Auto chButtton-Caps" type="button" onclick="chEPI()">Click to Update Profile</button></div>
    </div><div class="chfl chp1">My Information</div>
    <form enctype="multipart/form-data" id="chPersonalInfoForm">
   
    <div class="chContent-BPG-group" style="width:100% !important">
    <div id="chMfFields" style="width:100% !important">
    <div class="chContent-BPG-group-Value chContent-BPG-group-Value-Full" style="width:100% !important">
    <label for="company_name" class="chContent-BPG-group-Value-Label">Company Name:</label>
    <input type="text" class="companyMetafield" value="`+customerData.company_name+`" name="company_name_ext" id="company_name_ext" data-metafieldid="" data-isMetafield="true" data-metafieldnamespace="custom" data-metafieldkey="company_name" data-metafieldtype="single_line_text_field" style="width: calc(100% - 20px) !important">
    </div>

     <div class="chContent-BPG-group">
    <div id="chMfFields" class="taxExempt" style="display:none">
    <div class="chContent-BPG-group-Value chContent-BPG-group-Value-Half">
    <label for="company_name" class="chContent-BPG-group-Value-Label">Tax Country</label>
    <select class="taxValue" name="tax_country" id="tax_country" style="width: calc(100% - 20px) !important"></select>
    </div>
    <div class="chContent-BPG-group-Value chContent-BPG-group-Value-Half">
    <label for="company_name" class="chContent-BPG-group-Value-Label">Tax Region</label>
    <select class="taxValue" name="tax_region" id="tax_region" style="width: calc(100% - 20px) !important"></select>
    </div>
    <div class="chContent-BPG-group-Value chContent-BPG-group-Value-Half">
    <label for="company_name" class="chContent-BPG-group-Value-Label">Tax Exemption Reason</label>
    <select class="taxValue" name="tax_reason" id="tax_reason" style="width: calc(100% - 20px) !important">
    <option>A</option>
    <option>B</option>
    <option>C</option>
    <option>DS</option>
    </select>
    </div>
    </div>
    <div class="chContent-BPG-group-Value chContent-BPG-group-Value-Half chpCbw">
    <div  class="taxExemptSelect" style="margin-left:5%">
    <label class="chpCb">
    <input type="checkbox" id="tax_exempt" name="tax_exempt">
    <span class="chpCm"></span>Tax Exempt</label></div>
    </div>
    <div class="chContent-BPG-group-Action">
    
    <button class="chButton chButton-Auto chButton-Lg companyInfoSave" type="button">Save Details</button>
    <button class="chButton chButton-Auto chButton-Lg chButton-Outline" type="button">Cancel</button>
    </div>
    </div>
    </form>
    </div>
    </div>
    `);
  if(customerData.hasOwnProperty('accountOwner')){
      $('.chProfile').prepend(`
<div class="chP-head">My Account Manager</div>
<div class="chP-main mb-3">
                    <div class="chP-email"><i class="chicon chicon-u-em"></i>
                    `+customerData.accountOwner.email+`</div>
                    <div class="chP-address"><i class="chicon chicon-u-ad"></i>
                    `+customerData.accountOwner.firstName+` `+customerData.accountOwner.lastName+`<br>`+customerData.accountOwner.company_name+`<br>`+customerData.accountOwner.address1+`<br>`+customerData.accountOwner.city+` `+customerData.accountOwner.province+` `+customerData.accountOwner.zip+`<br>United States</div>
                </div>`);
  }
}
   if(customerData.taxExempt===true){
    $('#tax_exempt').prop('checked',true);
  } else {
    $('#tax_exempt').prop('checked',false);
  }
   $('#tax_exempt').change(function(){
     
      if($(this).prop('checked')=== true && customerData.taxExempt === false){
        $('.taxExempt').show();
        $('.taxExemptSelect').hide();
        handleTaxSettings(null,'start');
        $('#tax_country').change(function(){
          var taxObject = [{
            "name":"country",
            "value":this.value
          }]
          handleTaxSettings(taxObject,'country');
        })    
        $('#tax_region').change(function(){
          var taxObject = [
            {
            "name":"country",
            "value":$('#tax_country').val()
          },
             {
            "name":"region",
            "value":this.value
          },
          ]
          handleTaxSettings(taxObject,'region');
        }) 
        
         $('#tax_reason').change(function(){
          taxExemptCode = $("#tax_reason :selected").data('taxexemptioncode');
           alert(taxExemptCode);
        }) 
     
      } else {
        $('.taxExempt').hide();
        $('.taxExemptSelect').show();
Swal.fire({
  title: "Are you sure?",
  text: "You are electing to remove the tax exemption status from your account.",
  icon: "question",
  showCancelButton: true,
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  confirmButtonText: "Yes, remove it!"
}).then((result) => {
  if (result.isConfirmed) {
    var taxExemptObject = {
        "input":{
              "id": "gid://shopify/Customer/" + customer_id,
              "taxExempt":false
        }
      }
      

    shopifyExec('customerTaxExempt','Post',0,taxExemptObject,null);
    Swal.fire({
      title: "Deleted!",
      text: "Your file has been deleted.",
      icon: "success"
    });
  }
});
      }
    });
  $('.companyInfoSave').click(function(){
   
      var metafieldObject = {
        "metafields": [

        ]
    };
    $('.companyMetafield').each(function(){
      var value='';
      if($(this).data('metafieldtype')==="boolean"){
        value = $(this).prop('checked');
      }
      else {
        value=this.value;
      }
      var metafield = {
                        "key": $(this).data('metafieldkey'),
                        "namespace": $(this).data('metafieldnamespace'),
                        "ownerId": "gid://shopify/Customer/" + customer_id,
                        "value": value.toString(),
                        "type": $(this).data('metafieldtype')
                    }
                    metafieldObject.metafields.push(metafield);
    });
        shopifyExec('metafieldsSet','Post',0,metafieldObject,null);
setTimeout(function(){
      if(taxExemptCode != ''){
      var taxExemptObject = {
        "input":{
              "id": "gid://shopify/Customer/" + customer_id,
              "taxExempt":true,
              "taxExemptions": []
                }
      }
      taxExemptObject.input.taxExemptions.push(taxExemptCode);

    shopifyExec('customerTaxExempt','Post',0,taxExemptObject,null);

      
    }
},1000)

    
  })
}

function handleTaxSettings(procData,level){
  console.log('fetching settings');
  var proc_data = procData;
  console.log(proc_data);
  var settings = {
    url: localStorage["apiBaseUrl"] + "/api/DynamicDb/CallSp",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage["agchimpToken"],
    },
    data: JSON.stringify({
      storedProcedureName: 'shopify_frontend_json_tax_exempt_values_s',
      parameters: proc_data,
      procReturnsJson: true,
    }),
  };

  $.ajax(settings)
    .done(function (response) {
      console.log(response);
      if(level==='start'){
        var options = '';
        $.each(response,function(){
          options +=`<option value="`+this.countryName+`">`+this.countryName+`</option>`;
        });
        $('#tax_country').html(`<option value="">Select Country</option>` + options);
      }

      if(level==='country'){
        var options = '';
        $.each(response,function(){
          options +=`<option value="`+this.regionName+`">`+this.regionName+`</option>`;
        });
        $('#tax_region').html(`<option value="">Select Region</option>` + options);
      }

      if(level==='region'){
        var options = '';
        $.each(response,function(){
          options +=`<option data-taxexemptioncode="`+this.code+`" value="`+this.reasonName+`">`+this.reasonName+`</option>`;
        });
        $('#tax_reason').html(`<option value="">Select Exemption Reason</option>` + options);
      }
      
    })
    .fail(function (error) {
      console.log(error);
    });
}

<!-- Google tag (gtag.js) -->






          